import React, { useEffect } from 'react';

export default function Chatbot() {
  useEffect(() => {
    // Ensure Elfsight script is present and initialized
    const scriptSrc = 'https://elfsightcdn.com/platform.js';
    let script = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      className="elfsight-app-c56bc097-860f-4752-a406-b9bf619cc51a"
      data-elfsight-app-lazy
    />
  );
}
